export default __webpack_public_path__ + "static/media/optometrist.e19c38c4.png";